import { AUDIO_BUFFER } from "constants/constants";
import { useCallback, useEffect, useRef } from "react";
import { subscribeToAudio, unsubscribeToAudio } from "slices/mediaServerSlice";

const useAudioOrganiser = (luid, shouldHearAudio) => {
  const buffer = useRef(null);

  const engageAudio = useCallback(() => {
    buffer.current = null;
    subscribeToAudio(luid);
  }, [luid]);

  const disengageAudio = useCallback(() => {
    if (buffer.current) {
      clearTimeout(buffer.current);
      buffer.current = null;
    }
    unsubscribeToAudio(luid);
  }, [luid]);

  useEffect(() => {
    if (shouldHearAudio) {
      if (!buffer.current) {
        buffer.current = setTimeout(() => {
          engageAudio();
        }, AUDIO_BUFFER);
      }
    } else {
      disengageAudio();
    }
  }, [shouldHearAudio, engageAudio, disengageAudio]);

  useEffect(() => {
    return () => {
      disengageAudio();
    };
  }, [disengageAudio]);

  return null;
};
export default useAudioOrganiser;
